export {}; // TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from UserMessageProps.
// & Required<Pick<UserMessageProps, 'propName'>>
//# sourceMappingURL=UserMessage.types.js.map